import { render, staticRenderFns } from "./RehabCoursesMy.vue?vue&type=template&id=36b41614&scoped=true"
import script from "./RehabCoursesMy.vue?vue&type=script&lang=js"
export * from "./RehabCoursesMy.vue?vue&type=script&lang=js"
import style0 from "./RehabCoursesMy.vue?vue&type=style&index=0&id=36b41614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b41614",
  null
  
)

export default component.exports